const mode: 'development' | 'production' = process.env.NODE_ENV as ('development' | 'production') || 'development'

const url = {
    cdn: '//d3muynxv4b3dfn.cloudfront.net',
    cdnWordpress: '//dx2702aiu4qvj.cloudfront.net/health/wp-content/themes/finddoc/dist',
    web: (mode === 'development') ? 'http://localhost:8876' : 'https://finddoc.com',
    web_api: (mode === 'development') ? 'http://localhost:9226' : 'https://web.api.finddoc.io',
}

export const env = {
    mode,
    url,
};
